module.exports = __webpack_public_path__ + "static/media/title_featured.d760b9ca.svg";